import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { WorkflowBuilder } from '../components/whatsapp/WorkflowBuilder';
export function Workflows() {
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2404">
      <Sidebar data-id="element-2405" />
      <main className="flex-1 flex flex-col h-screen overflow-hidden" data-id="element-2406">
        <Header data-id="element-2407" />
        <div className="flex-1 overflow-y-auto p-6" data-id="element-2408">
          <div className="mb-6" data-id="element-2409">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-2410">
              Automation Workflows
            </h1>
            <p className="text-gray-500" data-id="element-2411">
              Create and manage automated communication flows
            </p>
          </div>
          <WorkflowBuilder data-id="element-2412" />
        </div>
      </main>
    </div>;
}